module.exports = "<p>\n  adminlogin works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/adminlogin/adminlogin.component.html
// module id = ./src/app/adminlogin/adminlogin.component.html
// module chunks = main